module.exports = __webpack_public_path__ + "static/media/sucesso.060e18f2.svg";